import createAxiosInstance from './create-axios-instance'
import { iframeRoutes } from '../routes/PublicRoutes'

const { instance: axiosInstance, cancelPreviousRequests } = createAxiosInstance(
    {
        baseURL: process.env.REACT_APP_API_URL,
        timeout: 60_000,
        headers: { 'Content-Type': 'application/json' }
    },
    [new Set([...iframeRoutes.map(route => route.path)])]
)

export { axiosInstance, cancelPreviousRequests }
export default axiosInstance
